import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { ErrorPage } from "./ErrorPage";
import { SignInPage } from "./pages/Auth/SignInPage";
import { SetPassword } from "./pages/Auth/SetPassword";
import { ProjectPage } from "./pages/Project/ProjectPage";
import { ProjectDetailsPage } from "./pages/Project/ProjectDetailsPage";
import { ClientsPage } from "./pages/Client/ClientsPage";
import { CreateClientPage } from "./pages/Client/CreateClientPage";
import { ResourcePage } from "./pages/ResourcePage";
import { TimelinePage } from "./pages/TimelinePage";
import { EditPage } from "./pages/EditPage";
import { HomePage } from "./pages/HomePage";
import { EditProject } from "./pages/Project/EditProject";
import { UsersPage } from "./pages/UsersPage";
import { InvitePage } from "./pages/InvitePage";
import { PatientList } from "./pages/Patient/PatientList";
import ClientDetails from "./pages/ClientDetails/Details";
import EditClientDetails from "./pages/ClientDetails/EditDetails";
import { PatientDetail } from "./pages/Patient/PatientDetails/Details";
import { EditPatient } from "./pages/Patient/PatientDetails/EditDetails";
import { Dashboard } from "./pages/Dashboard/Dashboard";
import { MedicationList } from "./pages/Medication/MedicationList";
import { MedicationDetails } from "./pages/Medication/MedicationDetails";
import { DiagnosticReportList } from "./pages/DiagnosticReport/DiagnosticReportList";
import { IntegrationPage } from "./pages/Integrations/IntegrationPage";
import IntegrationApplication from "./pages/Integrations/IntegrationApplication";
import Ehr from "./pages/Integrations/Ehr";
import Wear from "./pages/Integrations/Wear";
import { DiagnosticReportDetails } from "./pages/DiagnosticReport/DiagnosticReportDetails";
import { Appointment } from "./pages/Patient/PatientDetails/Appointments";
import { AppointmentPage } from "./pages/Appointment/Appointment";
import { DashboardScreen } from "./pages/Dashboard/DashboardScreen";
import { Clinicalnotes } from "./pages/ClinicalNotes/ClinicalNotes";
import { NewNote } from "./pages/ClinicalNotes/NewNote";
import { EditClnicalNotes } from "./pages/ClinicalNotes/EditClinicalNotes";
import NewClinicalNotes from "./pages/ClinicalNotes/NewClinicalNotes";
import { NewAppointment } from "./pages/Appointment/NewAppointment";
import AppointmentCall from "./pages/Appointment/AppointmentCall";
import { PatientVisits } from "./pages/Patient/PatientVisits/PatientVisit";
import { PatientJson } from "./pages/Patient/PatientDetails/Json";
import { PatientNotFound } from "./pages/Patient/PatientVisits/DataNotFound";
import NewPatientComponent from "./pages/Patient/PatientDetails/NewPatient";
import { FhirJson } from "./pages/Appointment/FhirResponse";
import { Capabilities } from "./pages/Fhir_Capabilities/Capabilities";
import { Eligibility } from "./pages/Eligibility/EligibilityList";
import { NewEligibility } from "./pages/Eligibility/NewEligibility";
import { EligibilityDetails } from "./pages/Eligibility/EligibilityDetails";
import BulkExport from "./pages/BulkExport/BulkExport";
import { Trigger } from "./pages/Hl7/Trigger";
import { Recipes } from "./pages/AIRecipes/Recipes";
import { Audit } from "./pages/Audit-Logs/Audit";
import { Questionnaire } from "./pages/questionnare/Questionnare";
import { QuestionnaireDetails } from "./pages/questionnare/QuestionnareDetails";
import { VoiceAi } from "./pages/questionnare/VoiceAi";
import { ReviewForm } from "./pages/questionnare/ReviewForm";
import { EmbedUI } from "./pages/Embed/AiEmbed";
import HealthCheckApp from "./pages/Embed/HealthCheck";
import { CategoryChat } from "./pages/questionnare/CategoryChat";
import { Insurance } from "./pages/Eligibility/Insurance";
import Referral from "./pages/Embed/Referral";
import Logistics from "./pages/Embed/Logistics";
import EpicLaunch from "./pages/Embed/epic/EpicLaunch";
import { EpicEmbed } from "./pages/Embed/epic/EpicSummary";
import { EmbedAppsLaunch } from "./pages/Embed/EmbedAppsLaunch";
import { AvailityForm } from "./pages/Availity/AvailityForm";
// import PriorAuth from "./pages/Availity/PriorAuth";
import { PreAuthDetails } from "./pages/Availity/Dashboard-priorAuth";
import PriorAuth from "./pages/Eligibility/Availity/PriorAuth";
import { ClaimForm } from "./pages/Eligibility/claims/ClaimForm";
import { ClaimDetails } from "./pages/Eligibility/claims/ClaimDetails";
import ClaimList from "./pages/Eligibility/claims/ClaimList";
import { NewCarePlan } from "./pages/CarePlan/NewCareplan";
import CarePlanEmbed from "./pages/Embed/CareplanEmbed";
import { EmbedAIChat } from "./pages/questionnare/EmbedAIChat";
const RedirectToPatientDetails = () => {
  const { patientId } = useParams();

  return <Navigate to={`/patient/details/${patientId}`} replace />;
};

export function AppRoutes(): JSX.Element {
  return (
    <Routes>
      <Route errorElement={<ErrorPage />}>
        <Route path="/signin" element={<SignInPage />} />
        <Route
          path="/healthconnect-ai-summary/:code"
          element={<EmbedUI aiName="summary" />}
        />
        <Route
          path="/healthconnect-epic-ai-summary/:code"
          element={<EpicEmbed aiName="summary" />}
        />
        <Route
          path="/healthconnect-ai-cardio/:code"
          element={<EmbedUI aiName="cardio" />}
        />
        <Route
          path="/healthconnect-ai-readmission/:code"
          element={<EmbedUI aiName="reAdmission" />}
        />
        <Route
          path="/healthconnect-ai-symptom/:code"
          element={<EmbedUI aiName="symptom" />}
        />
        <Route path="/healthconnect-ai-referral/:code" element={<Referral />} />
        <Route
          path="/healthconnect-ai-los/:code"
          element={<EmbedUI aiName="los" />}
        />
        <Route
          path="/healthconnect-ai-logistics/:code"
          element={<Logistics aiName="logistics" />}
        />
        <Route
          path="/launch-logistics"
          element={<HealthCheckApp aiName="logistics" />}
        />
         <Route
          path="/launch-careplan"
          element={<HealthCheckApp aiName="careplan" />}
        />
        <Route path="/launch-epic" element={<EpicLaunch />} />

        <Route
          path="/launch-summary"
          element={<HealthCheckApp aiName="summary" />}
        />
        <Route
          path="/launch-cardio"
          element={<HealthCheckApp aiName="cardio" />}
        />
        <Route
          path="/launch-referral"
          element={<HealthCheckApp aiName="referral" />}
        />
        <Route path="/launch-los" element={<HealthCheckApp aiName="los" />} />
        <Route path="/launch-chat" element={<HealthCheckApp aiName="chat" />} />
        <Route path="/launch-qnr" element={<HealthCheckApp aiName="qnr" />} />
        <Route path="/launch-form" element={<HealthCheckApp aiName="form" />} />
        <Route path="/admin/smartonfhir-apps" element={<EmbedAppsLaunch />} />

        <Route
          path="/launch-readmission"
          element={<HealthCheckApp aiName="readmission" />}
        />

        <Route
          path="/launch-symptom"
          element={<HealthCheckApp aiName="symptom" />}
        />

        <Route path="/setpassword/:id/:secret" element={<SetPassword />} />
        <Route path="client/new" element={<EditClientDetails />} />
        <Route
          path="client/details/:resourceType/:clientId"
          element={<ClientDetails />}
        />
        <Route
          path="client/edit/:resourceType/:clientId"
          element={<EditClientDetails />}
        />
        <Route
          path="client/json/:resourceType/:clientId"
          element={<ClientDetails />}
        />
        <Route path="patient" element={<PatientList />} />
        <Route
          path="/patient/:patientId"
          element={<RedirectToPatientDetails />}
        />

        <Route path="patient/details/:patientId" element={<PatientDetail />} />
        <Route path="patient/details/new" element={<NewPatientComponent />} />

        <Route path="patient/edit/:patientId" element={<EditPatient />} />
        <Route
          path="patient/FHIR Response/:patientId"
          element={<PatientJson />}
        />

        <Route path="/admin/dashboard" element={<DashboardScreen />} />
        <Route path="admin/appointments" element={<AppointmentPage />} />
        <Route path="admin/appointments/new/:id" element={<NewAppointment />} />
        <Route path="/healthconnect-ai-chat/:code" element={<CategoryChat />} />
        <Route path="/healthconnect-ai-agent/:code" element={<EmbedAIChat />} />
        <Route
          path="/healthconnect-ai-qnr/:code"
          element={<CategoryChat type="qnr" />}
        />
         <Route
          path="/healthconnect-ai-careplan/:code"
          element={<CarePlanEmbed />}
        />
        <Route
          path="/healthconnect-ai-form/:code"
          element={<CategoryChat form={true} />}
        />

        <Route
          path="admin/appointments/call/:patientId"
          element={<AppointmentCall />}
        />
        <Route
          path="admin/appointments/:appointmentId"
          element={<FhirJson resourceType={"Appointment"} />}
        />

        <Route path="admin/clinical-notes" element={<Clinicalnotes />} />
        <Route
          path="admin/clinical-notes/new-clinical-notes/:id"
          element={<NewClinicalNotes />}
        />
        <Route
          path="admin/Clinical_Notes/Edit_Clinical_Notes"
          element={<EditClnicalNotes />}
        />
         <Route
          path="admin/care-plan"
          element={<NewCarePlan />}
        />

        <Route path="/admin/medications" element={<MedicationList />} />
        {/* <Route path="/admin/Patientvisits" element={<PatientVisits />} /> */}
        <Route path="/admin/ai-recipes" element={<Recipes />} />

        <Route
          path="/admin/medications/:medicationId"
          element={<MedicationDetails />}
        />
        <Route
          path="/admin/voice-assist-ai/questionnare-list"
          element={<Questionnaire />}
        />
        <Route path="/admin/voice-assist-ai" element={<VoiceAi />} />

        <Route
          path="/admin/voice-assist-ai/questionnare-list/details/:patientID"
          element={<QuestionnaireDetails />}
        />
        <Route path="/admin/:qtrId" element={<ReviewForm />} />

        <Route path="/admin/fhircapabilities" element={<Capabilities />} />
        <Route path="/admin/insurance/eligibility" element={<Eligibility />} />

        <Route path="/admin/insurance/claims" element={<ClaimList />} />
        <Route path="/admin/insurance/claims/new" element={<ClaimForm />} />

        <Route path="/admin/insurance" element={<Insurance />} />
        <Route
          path="admin/insurance/eligibility/new"
          element={<NewEligibility />}
        />

        <Route
          path="admin/insurance/prior-auth/new"
          element={<AvailityForm />}
        />
        <Route
          path="admin/insurance/prior-auth"
          element={<PriorAuth />}
        />
        <Route
          path="admin/insurance/prior-auth-dashboard"
          element={<PreAuthDetails />}
        />  <Route
        path="admin/insurance/claims/details"
        element={<ClaimDetails />}
      />

        <Route
          path="admin/insurance/eligibility/details"
          element={<EligibilityDetails />}
        />
        <Route path="/admin/bulk-export" element={<BulkExport />} />
        <Route path="/admin/hl7-trigger" element={<Trigger />} />

        <Route
          path="/admin/diagnosticreport"
          element={<DiagnosticReportList />}
        />
        <Route path="/admin/audit-events" element={<Audit />} />
        <Route
          path="/admin/diagnosticreport/:resultId"
          element={<DiagnosticReportDetails />}
        />
        <Route path="/admin" element={<IntegrationPage />}>
          <Route
            path="Integration"
            element={<IntegrationApplication />}
          ></Route>
          <Route path="project" element={<ProjectDetailsPage />} />
          <Route path="details" element={<ProjectDetailsPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="invite" element={<InvitePage />} />
          <Route path="ehrConnect" element={<ClientsPage />} />

          <Route
            path="ehrConnect/new"
            element={<CreateClientPage isNew={true} />}
          />
          <Route path="wearconnect" element={<ClientsPage />} />
          <Route
            path="wearconnect/new"
            element={<CreateClientPage isNew={true} />}
          />
          <Route path="edit" element={<EditProject />} />
        </Route>
        <Route path="/admin/integration/ehr" element={<Ehr />}></Route>
        <Route path="/admin/integration/wear" element={<Wear />}></Route>
        <Route path="admin/:resourceType/:id" element={<ResourcePage />}>
          <Route index element={<TimelinePage />} />
          <Route path="edit" element={<EditPage />} />
        </Route>
        <Route path="/:resourceType" element={<HomePage />} />
        <Route path="/" element={<HomePage />} />
      </Route>
    </Routes>
  );
}
